<div class="header-control" [class.full-width]="fullWidth">
  <button 
    type="button"
    class="header-control-trigger select-wrap" 
    [class.active]="isOpen" 
    (click)="toggleOpen($event)"
    [attr.aria-expanded]="isOpen">
    
    <!-- Icons -->
    <svg *ngIf="iconType === 'calendar'" class="control-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <rect width="18" height="18" x="3" y="4" rx="2" ry="2"/>
      <line x1="16" x2="16" y1="2" y2="6"/>
      <line x1="8" x2="8" y1="2" y2="6"/>
      <line x1="3" x2="21" y1="10" y2="10"/>
    </svg>

    <svg *ngIf="iconType === 'graduation'" class="control-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M22 10v6M2 10l10-5 10 5-10 5z"/>
      <path d="M6 12v5c3 3 9 3 12 0v-5"/>
    </svg>

    <svg *ngIf="iconType === 'filter'" class="control-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>
    </svg>

    <svg *ngIf="iconType === 'list'" class="control-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M3 6h18"/>
      <path d="M7 12h10"/>
      <path d="M10 18h4"/>
    </svg>

    <span class="value-text">{{ value || placeholder }}</span>

    <svg class="chevron-icon" [class.rotated]="isOpen" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="6 9 12 15 18 9"/>
    </svg>
  </button>

  <div *ngIf="isOpen" class="popover" [class.left]="alignLeft" (click)="$event.stopPropagation()">
    <button 
      *ngFor="let option of options" 
      type="button"
      class="popover-item" 
      [class.selected]="value === option"
      (click)="selectOption(option, $event)">
      <span>{{ option }}</span>
      <svg *ngIf="value === option" class="check-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="20 6 9 17 4 12"/>
      </svg>
    </button>
  </div>
</div>
